import { effect, Injectable } from '@angular/core';
import { currentUserId, selectedOrganizationId } from '../current-user-id';
import { DB_COMMON_CACHE_TABLE } from './db-types';
import { AppIndexedDb } from './db';

interface CachedResult {
    key: string;
    result: object;
}

@Injectable({ providedIn: 'root' })
export class CommonCacheDb extends AppIndexedDb<CachedResult> {

    public override tableName: string = DB_COMMON_CACHE_TABLE;

    constructor() {
        super();

        effect(async () => {
            currentUserId();
            await this.clearOnUserChange();
        });
    }

    /**
     * Creates a store - MUST be called within onupgradeneeded event
     */
    public initializeStore(db: IDBDatabase): void {
        const store = db.createObjectStore(this.tableName, { keyPath: 'key' });
        store.createIndex('userId', 'userId');
    }

    public setDatabase(db: IDBDatabase): void {
        this.db = db;
    }

    public async store(resource: string, method: string, result: any): Promise<void> {
        const request = this.requestKey(resource, method);
        await this.put({ key: request, result });
    }

    public async getStored<T>(resource: string, method: string): Promise<T | null> {
        const request = this.requestKey(resource, method);
        const cache = await this.get(request);

        return (cache?.result || null) as any;
    }

    // TODO add input or only cache specific requests?
    private requestKey(resource: string, method: string): string {
        return `${resource}.${method}.${selectedOrganizationId()}`;
    }

}
